// components/WhatsAppFloatingButton.js
import React from "react";
import { MessageCircle,Phone } from "lucide-react";
import { useUser } from "../../context/useUser";

const WhatsAppFloatingButton = () => {
    const { country } = useUser()
    const phone = country === "PK" ? "923052023333" : "1888321ALIF";
    const message = "Hello!";
    const whatsappLink = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;

    return (
        <a
            href={whatsappLink}
            target="_blank"
            rel="noopener noreferrer"
            className="fixed bottom-6 right-6 bg-green-500 hover:bg-green-600 text-white p-4 rounded-full shadow-lg transition-all duration-300 z-50"
            title="Chat on WhatsApp"
        >
            <Phone size={24} />
        </a>
    );
};

export default WhatsAppFloatingButton;
